<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name+`:`">
				<div style="font-size: 1rem;font-weight: bold;">{{inputmodel[`${item.model}`]}}</div>
			</el-form-item>
			<el-form-item label="门锁别名"><br>
				<el-input v-model="inputmodel['lockAlias']" autocomplete="off" @blur="locknamechange()"></el-input>
			</el-form-item>
			<el-form-item label="门锁密码"><br>
				<el-input v-model="inputmodel['pwds'].keyboardPwd" autocomplete="off" @blur="lockpwdchange()"></el-input>
			</el-form-item>
		</el-form>
		<div style="	display: flex;
		justify-content: center;">
			<span style="color:#808080 ;"> 点击门锁名称或门锁密码即可修改</span>
		</div>
		<div class="bottom_button">
			<!-- <el-button @click="qx(1)">取 消</el-button> -->

			<el-button style="width: 50%;" type="primary" @click="qx()">修改密码</el-button>
		</div>
	</div>
</template>

<script>
	import {
		lock_pwd_change,
		lock_name_change
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '识别码',
					model: 'lockId'
				}, {
					name: '蓝牙名称',
					model: 'lockName'
				}, {
					name: '剩余电量',
					model: 'electricQuantity'
				}, {
					name: '绑定房间号',
					model: 'room_num'
				}],
				inputmodel: {},
				rules: {}
			}
		},
		props: [
			"item"
		],
		methods: {
			qx(i) {
				this.$emit('changedia', false)
				this.$parent.$parent.$parent.contractlistcontractlist();
			},
			async lockpwdchange() {
				this.$confirm(`是否修改门锁别名：${this.inputmodel.lockAlias}的密码？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					lock_pwd_change({
						lockid: this.inputmodel.lockId,
						pwd: this.inputmodel.pwds.keyboardPwd
					}).then(res => {
						this.Messages(res)
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消修改'
					});
				});

			},
			async locknamechange() {
				this.$confirm(`是否修改门锁别名：${this.inputmodel.lockAlias} 的别名为：${this.inputmodel.lockAlias}？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					lock_name_change({
						lockid: this.inputmodel.lockId,
						name: this.inputmodel.lockAlias
					}).then(res => {
						this.Messages(res)
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消修改'
					});
				});
			},

			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
		},
		created() {
			this.inputmodel = JSON.parse(JSON.stringify(this.item));
		},
		watch: {
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);
				this.inputmodel = JSON.parse(JSON.stringify(this.item));


			}
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>